import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { IStorageSession } from "namirasoft-core";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { DonateLayout } from "./DonateLayout";
import { DonateRoutes } from "./DonateRoutes";
import DonatePage from "./pages/DonatePage";
import DonateSuccessPage from "./pages/DonateSuccessPage";
import LoginPage from "./pages/LoginPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_DONATE}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let servers = { donate: null };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows => (<Routes>
                        <Route path={DonateRoutes.Home} element={<DonatePage {...result} servers={servers} />} />

                        <Route path={DonateRoutes.Donate} element={<DonatePage {...result} servers={servers} />} />
                        <Route path={DonateRoutes.DonateSuccess} element={<DonateSuccessPage {...result} servers={servers} />} />

                        {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                        <Route path="*" element={<NSNotFoundPage />} />
                    </Routes >))}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={DonateRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <DonateLayout
                {...props}
            >
                {props.children}
            </DonateLayout>
        )}
        requirement={{
            verification: {
                email: false,
                phone: false
            }
        }}
    />
}

export default Router;